<template>
  <v-container fluid >
    <v-slide-y-transition mode="out-in">
      <v-layout column class="elevation-4">
        <v-tabs centered v-model="activeTab">
          <v-tab >
            Student Directory
          </v-tab>
          <v-tab >
            Classes
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item >
            <student-list></student-list>
          </v-tab-item>
          <v-tab-item >
            <students-by-class></students-by-class>
          </v-tab-item>
        </v-tabs-items>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>


<script>
import StudentList from '../components/StudentList.vue';
import StudentsByClass from '../components/StudentsByClass.vue';
// var db = firebase.firestore();

// // Disable deprecated features
// db.settings({
//   timestampsInSnapshots: true
// });

export default {
  name: 'Students',
  data () {
    return {
      activeTab: 0
    }
  },
  components : {
    'student-list': StudentList,
    'students-by-class': StudentsByClass
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
